export default "__VITE_ASSET__Cr$r2J0p__"